/**
 * The cohort's list, access side (08.10.2026): one chip per account, the
 * filters above the list, and the summary line. Built on the same account
 * summary the enrolment panel reads; never a password.
 */
import { accountLine } from "./limoAccount";

const CHIP = {
  ok: "bg-[#EAF4EE] text-[#2F6B4E]",
  off: "bg-[#FDECEC] text-[#9b1f2c]",
  warn: "bg-[#FDF3E7] text-[#8a6a1a]",
  unknown: "bg-[#EDEEF0] text-[#6B7280]",
};

/** `{label, cls, title}` for the account chip; title is the full sentence. */
export function accountChip(account) {
  const line = accountLine(account);
  if (!line) return null;
  let label = "necunoscut";
  if (account?.ok !== false && account?.found === false) label = "negăsit la Logiscool";
  else if (account?.enabled === true) label = "cont activ";
  else if (account?.enabled === false) label = account.disabled_by_us ? "dezactivat de noi" : "dezactivat";
  return { label, cls: CHIP[line.tone], title: line.text };
}

/** "parolă generată" / "parolă schimbată", or null when unknown. */
export function passwordChip(account) {
  if (!account?.found || typeof account.password_known !== "boolean") return null;
  return account.password_known
    ? { label: "parolă generată", cls: "bg-[#F5F6F6] text-[#6B7280]" }
    : { label: "parolă schimbată", cls: "bg-[#FDF3E7] text-[#8a6a1a]" };
}

export const ACCESS_FILTERS = [
  { key: "all", label: "Toți" },
  { key: "disabled", label: "Dezactivate" },
  { key: "changed", label: "Parolă schimbată" },
  { key: "not_sent", label: "Date netrimise" },
];

/** Whether a participant shows under the chosen filter. Those not at
 *  Logiscool yet show only under "Toți". */
export function matchesFilter(item, account, key) {
  if (key === "all") return true;
  if (!account) return false;
  if (key === "disabled") return account.enabled === false;
  if (key === "changed") return Boolean(account.found) && account.password_known === false;
  if (key === "not_sent") return !item.access_sent_at;
  return true;
}

/** "18 conturi active · 2 dezactivate · 3 fără date trimise". */
export function accessSummary(counts) {
  if (!counts) return "";
  const parts = [`${counts.active} ${counts.active === 1 ? "cont activ" : "conturi active"}`];
  if (counts.disabled) parts.push(`${counts.disabled} ${counts.disabled === 1 ? "dezactivat" : "dezactivate"}`);
  if (counts.password_changed) parts.push(`${counts.password_changed} cu parola schimbată`);
  if (counts.not_sent) parts.push(`${counts.not_sent} fără date trimise`);
  if (counts.unknown) parts.push(`${counts.unknown} cu starea necunoscută`);
  return parts.join(" · ");
}
